import { ObjectValues } from 'common/tsHelpers';

export const FEATURE_FLAGS_MODULES = {
  SIM_INVENTORY: 'simInventory',
  BULK_PROVISIONING: 'bulkProvisioning',
  AUDIT_TRAIL: 'auditTrail',
} as const;

export type FeatureFlagsModules = ObjectValues<typeof FEATURE_FLAGS_MODULES>;
